import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import "./ModalOverlay.css";

function ModalOverlay({ children, onClose }) {
  return (
    <div className="modal-overlay">
      <Icon
        size="large"
        name="close"
        onClick={onClose}
        data-test="overlay-close-button"
        className="modal-overlay-close-button"
      />

      {children}
    </div>
  );
}

ModalOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalOverlay;
